import { Navigate, Outlet, useLocation } from "react-router-dom";
import { IUser } from "../context/authProvider";
import CustomerTerms from "../components/core/customerTerms";
import AdvertiserRequirements from "../components/core/admin/adminRequirements";

export default function RequireAuth({ user, roles = ["customer"], term }: { user: IUser | null, roles?: string[], term?: { [key: string]: any } | null }) {

    const location = useLocation();

    return (
        user && user?.roles?.includes("advertiser") && roles.includes("advertiser") && (!user?.cpf || !user.phoneVerified || !user?.emailVerified || !user?.advertiserTermsAccepted?.accepted || user.advertiserTermsAccepted?.version !== term?.version) ?
            <AdvertiserRequirements term={term}/>
            :
            user && user?.roles?.includes("customer") && roles.includes("customer") && (!user?.termsAccepted?.accepted || user.termsAccepted?.version !== term?.version) ?
                <CustomerTerms term={term} />
                :
                user && !user.roles.some(role => roles.includes(role)) ?
                    <p>Não autorizado</p>
                    :
                    user && user.roles.some(role => roles.includes(role)) ?
                        <Outlet />
                        :
                        <Navigate to="/gatekeeper" state={{ from: location }} />
    )
}
